// #region Global Imports
import React from 'react';
// #endregion Global Imports
// #region Local Imports
import { gql } from '@generated/gql';
import { getFragmentData } from '@generated/fragment-masking';
import type { IProps } from '@components/Paragraphs/ParagraphMedia/ParagraphMedia';
import type { FragmentType } from '@generated/fragment-masking';
import { Image } from './Image';
import { Video } from './Video';
import { Audio } from './Audio';
import styles from './ParagraphMedia.module.sass';
import type { ImageFragment } from './Image';
import type { VideoFragment } from './Video';
import type { AudioFragment } from './Audio';
// #endregion Local Imports

export const ParagraphMediaFragment = gql(/* GraphQL */ `
  fragment ParagraphMediaFragment on ParagraphMedia {
    media: fieldMedia {
      entity {
        __typename
        uuid
        ...ImageFragment
        ...VideoFragment
        ...AudioFragment
      }
    }
  }
`);

export const ParagraphMedia: React.FunctionComponent<IProps.ParagraphMedia> = ({
  paragraph: _paragraph,
}) => {
  const paragraph = getFragmentData(ParagraphMediaFragment, _paragraph);

  return (
    <div className={styles.Media__root}>
      {paragraph.media?.map((value) => {
        const entity = value?.entity;

        const type = entity?.__typename;
        return (
          <div className={styles.Media__item} key={String(entity?.uuid)}>
            {type === 'MediaImage' && (
              <Image
                hasLightBox
                image={entity as FragmentType<typeof ImageFragment>}
              />
            )}
            {type === 'MediaRemoteVideo' && (
              <Video video={entity as FragmentType<typeof VideoFragment>} />
            )}
            {type === 'MediaAudio' && (
              <Audio audio={entity as FragmentType<typeof AudioFragment>} />
            )}
          </div>
        );
      })}
    </div>
  );
};
